<template>
    <div>
        <validation-provider rules="required" v-slot="{ errors, valid, validated }">
            <b-form-group
                label="Titolo"
                label-for="title"
                class="col-md-4">
                <b-form-input
                    id="title"
                    :value="value.title"
                    :state="!validated ? null : valid"
                    @input="updateValue({ title: $event })"></b-form-input>
                <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>
        <b-form-group
            label="Dominio"
            label-for="domain"
            class="col-md-4">
            <b-form-input
                id="domain"
                :value="value.domain"
                @input="updateValue({ domain: $event })"></b-form-input>
        </b-form-group>
        <b-form-group
            label="Tipo"
            label-for="type"
            class="col-md-4">
            <b-form-select
                id="type"
                :options="typeOptions"
                :value="value.type"
                @input="updateValue({ type: $event })"></b-form-select>
        </b-form-group>
        <b-form-group
            label="Scrivi messaggi come (default)"
            label-for="default-fake-author"
            class="col-md-4">
            <b-form-input id="default-fake-author"
                          :value="value.default_fake_author"
                          @input="updateValue({ default_fake_author: $event })"></b-form-input>
        </b-form-group>
        <b-form-group
            label="Template"
            label-for="template"
            class="col-md-4">
            <b-form-select
                id="template"
                :options="templateOptions"
                :value="value.template"
                @input="updateValue({ template: $event })"></b-form-select>
        </b-form-group>
        <b-form-group
            label="Data e ora di inizio"
            label-for="live-at"
            class="col-md-4">
            <flat-pickr
                id="live-at"
                :value="value.live_at"
                @input="updateValue({ live_at: $event })"
                :config="flatPickrConfig"
                class="form-control"></flat-pickr>
        </b-form-group>
        <b-form-group
            label="Data e ora di chiusura delle registrazioni"
            label-for="registration-close-at"
            class="col-md-4">
            <div class="input-group date">
                <flat-pickr
                    id="registration-close-at"
                    :value="value.registration_close_at"
                    @input="updateValue({ registration_close_at: $event })"
                    :config="flatPickrConfig"
                    class="form-control"></flat-pickr>
                <div class="input-group-append">
                    <button  @click="updateValue({ registration_close_at: '' })" class="btn btn-outline-secondary" type="button" title="Clear" data-clear>
                        <i class="fa fa-times">
                            <span aria-hidden="true" class="sr-only">Clear</span>
                        </i>
                    </button>
                </div>
            </div>
        </b-form-group>
        <div class="col-md-4">
            <b-form-checkbox
                :checked="settings['check_all_fields']"
                @input="setSetting('check_all_fields', $event)" switch>
                Controlla la compilazione dei campi prima di accedere
            </b-form-checkbox>
            <b-form-checkbox :checked="settings['chat_moderation']" @input="setSetting('chat_moderation', $event)" switch>
                Abilita moderazione della chat
            </b-form-checkbox>
        </div>

        <b-form-group
            label="Codice Embed"
            label-for="embed-code"
            class="col-md-12 mt-3">
            <ace-editor
                id="embed-code"
                style="height: 150px"
                @init="htmlEditorInit"
                :value="value.embed_code"
                @input="updateValue({ embed_code: $event })"
                lang="html"></ace-editor>
        </b-form-group>
        <div class="col-md-4">
            <b-form-checkbox v-model="value.visible">
                Visibile
            </b-form-checkbox>
        </div>
        <b-form-group
            v-if="value.id"
            label="Pagina Moderazione"
            label-for="domain"
            class="col-md-4">
            <b-form-input
                id="domain"
                :value="adminPublicCode"
                readonly></b-form-input>
        </b-form-group>
        <b-form-group
            v-if="value.id"
            label="Pagina Risultati Quiz"
            label-for="domain"
            class="col-md-4">
            <b-form-input
                id="domain"
                :value="quizPublicCode"
                readonly></b-form-input>
        </b-form-group>
        <b-form-group
            v-if="value.id"
            label="Pagina Chat"
            label-for="domain"
            class="col-md-4">
            <b-form-input
                id="domain"
                :value="chatPublicCode"
                readonly></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import gql from "graphql-tag";
import flatPickr from 'vue-flatpickr-component';

export default {
    name: "InfoTab",
    data() {
        return {
            typeOptions: [
                { value: null, text: '-' },
                { value: 'STREAMING', text: 'Streaming'},
                { value: 'MEETING', text: 'Meeting' }
            ],
            flatPickrConfig: {
                dateFormat: 'Z',
                enableTime: true,
                altFormat:  'd/m/Y H:i',
                altInput: true,
                allowInput: true,
            },
        }
    },
    apollo: {
        templates: gql`query {
            templates {
                key,
                name
            }
        }`,
    },
    props: {
        value: Object,
    },
    computed: {
        templateOptions() {
            const templates = [
                { value: null, text: "-" }
            ]
            if (this.$apollo.queries.templates.loading) return templates
            return [
                ...templates,
                ...this.templates.map((item) => { return { value: item.key, text: item.name }})
            ]
        },
        settings() {
            if (!this.value.settings) {
                return {}
            }
            return JSON.parse(this.value.settings)
        },
        adminPublicCode() {
            return `https://cvmevents.live/mod/${this.value.admin_public_code}`
        },
        chatPublicCode() {
            return `https://cvmevents.live/chat/${this.value.chat_public_code}`
        },
        quizPublicCode() {
            return `https://cvmevents.live/quizzes/${this.value.admin_public_code}`
        }
    },
    methods: {
        updateValue(options) {
            this.$emit('input', {
                ...this.value,
                ...options
            })
        },
        setSetting(key, value) {
            let settings = this.settings
            settings[key] = value
            this.updateValue({ settings: JSON.stringify(settings) })
        },
        htmlEditorInit(editor) {
            require('ace-builds/src-min-noconflict/ext-language_tools')
            require('ace-builds/src-min-noconflict/mode-html')
            require('ace-builds/src-min-noconflict/theme-ambiance')
            editor.session.setMode("ace/mode/html")
            editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true
            });
        }
    },
    components: {
        flatPickr
    }
}
</script>

<style scoped>

</style>
